export default "__VITE_ASSET__8c39575c__"